<div class="navbar">
  <credo-bank-navbar-item [position]="'start'">
    <div class="logo">SOL</div>
  </credo-bank-navbar-item>
  <credo-bank-navbar-item [position]="'end'">
    Already using? <span>Sign in</span>
  </credo-bank-navbar-item>
</div>
